<template>
  <aside class="sidebar">
    <div class="brand d-flex align-items-center">
      <img src="/static/primary-logo.png" class="main-logo" alt="Nutrinza" >
      <img src="/static/mobile-logo.png" class="mobile-logo" alt="Nutrinza" >
    </div>
    <div class="sidebar-inner">
      <nav class="primary-nav">
        <router-link id="quoteNav" tag="a" to="/quote">
          <truck-icon size="20" class="icon"/> <span class="nav-label">Quote</span>
        </router-link>
        <router-link id="logoutNav" tag="a" to="/logout" exact>
          <lock-icon size="20" class="icon"/> <span class="nav-label">Logout</span>
        </router-link>
        <b-tooltip target="quoteNav" title="Quote" placement="'right'" boundary="'window" />
        <b-tooltip target="logoutNav" title="Logout" placement="'right'" boundary="'window" />
      </nav>
    </div>
  </aside>
</template>

<script>
import { TruckIcon, LockIcon } from 'vue-feather-icons';

export default {
  name: "AppSidebar",
  components: {
    TruckIcon,
    LockIcon
  },
  props: {},
  methods: {
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
.tooltip {
  display: none !important;
}
.sidebar {
  background-color: $ui-gray-lightest;
  border-right: 1px solid $ui-gray-lighter;
  bottom: 0;
  position: fixed;
  top: 0;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: $sidebar-width;
  z-index: 1000;

  .brand {
    background: #fff;
    box-shadow: 0 rem-calc(2) rem-calc(15) rgba($ui-dark, 0.075);
    padding: 0 rem-calc(30);
    height: $header-height;
    width: 100%;
    .main-logo {
      display: block;
      margin: 0 auto;
      max-width: rem-calc(160);
    }
    .mobile-logo {
      display: none;
      margin: 0 auto;
      width: 0;
      height: auto;
      opacity: 0;
      -webkit-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
  }

  .sidebar-inner {
    position: relative;
    height: 100%;
    overflow-y: auto;
    padding-top: rem-calc(20);
    padding: rem-calc(20);

    .primary-nav {
      padding-bottom: rem-calc(50);
      a {
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        color: $ui-gray;
        text-align: left;
        font-size: .9rem;
        padding: rem-calc(8) rem-calc(12);
        transition: all 200ms;
        margin-bottom: rem-calc(4);
        border-radius: $border-radius;
        .icon {
          display: inline-block;
          text-align: left;
          margin: 0 rem-calc(12) 0 0;
          color: $ui-gray-mid;
        }

        &:hover {
          text-decoration: none;
          background-color: $ui-gray-lighter;
          color: $ui-gray;
          opacity: 1;
          .icon {
            color: $ui-gray;
          }
        }

        &.active {
          text-decoration: none;
          color: $brand-primary;
          background-color: rgba($brand-primary,0.1);
          cursor: default;
          .icon {
            color: $brand-primary;
          }
          &:hover {
            &::before {
              content: none;
            }
          }
        }
      }
    }
  }
}

// Responsive Overrides
@media (max-width: 1280px) {
  .tooltip {
    display: block !important;
  }
  .sidebar {
    width: $sidebar-width-small;
    .brand {
      padding: 0 rem-calc(8);
      .main-logo {
        display: none;
      }
      .mobile-logo {
        display: block;
        width: 100%;
        opacity: 1;
        transition-delay: 1s;
      }
    }
    .sidebar-inner {
      padding: rem-calc(4);
      border-radius: rem-calc(2);
      .primary-nav {
        a {
          .icon {
            margin: 0 auto;
          }
          .nav-label {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppSidebar.vue